module.exports = __webpack_public_path__ + "img/hexagon-logo.159056ad.png";